(function(){
  function reveal(){
    var els=document.querySelectorAll('.bh-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{threshold:0,rootMargin:'0px 0px -8% 0px'});
    setTimeout(function(){document.querySelectorAll('.bh-reveal:not(.is-in)').forEach(function(e){e.classList.add('is-in')})},2500);
    els.forEach(function(e){io.observe(e)});
  }
  function lightbox(){
    document.querySelectorAll('[data-bh-gallery]').forEach(function(g){
      if(g.dataset.bound)return;g.dataset.bound=1;
      var items=[].slice.call(g.querySelectorAll('[data-full]'));
      var lb=g.parentNode.querySelector('.bh-lightbox');if(!lb||!items.length)return;
      var img=lb.querySelector('img'),i=0;
      function show(n){i=(n+items.length)%items.length;img.src=items[i].dataset.full;img.alt=items[i].dataset.alt||'';}
      items.forEach(function(it,n){it.addEventListener('click',function(){show(n);lb.classList.add('is-open');document.body.style.overflow='hidden'})});
      function close(){lb.classList.remove('is-open');document.body.style.overflow=''}
      lb.querySelector('.bh-lightbox__close').onclick=close;
      lb.querySelector('.bh-lightbox__prev').onclick=function(e){e.stopPropagation();show(i-1)};
      lb.querySelector('.bh-lightbox__next').onclick=function(e){e.stopPropagation();show(i+1)};
      lb.addEventListener('click',function(e){if(e.target===lb)close()});
      document.addEventListener('keydown',function(e){if(!lb.classList.contains('is-open'))return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(i-1);if(e.key==='ArrowRight')show(i+1)});
    });
  }
  function init(){reveal();lightbox()}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
